import { useState } from 'react';
import { useSelector } from 'react-redux';
import MenuItemWithPopover from './TopBar/MenuItem/MenuItemWithPopover';
import { REQUEST_STATUS } from '../../../../redux_store';
import { ReactComponent as MenuIcon } from 'assets/icons/expand_circle_down.svg';

const TableMenu = ({
                     tableMenuPopoverOptions,
                     tableMenuStatus,
                     isLoading,
                   }) => {
  const { en } = useSelector((state) => state.i18n);
  const { tables: tTables } = en;
  const [anchorElMulti, setAnchorElMulti] = useState();

  return isLoading
    ? <div style={{
      maxHeight: 20,
      borderRadius: '0.25rem',
      position: 'absolute',
      display: 'flex',
      backgroundColor: '#dee2e6',
      visibility: 'visible',
      width: 30,
      height: 20,
      left: '50%',
      top: '0%',
      transform: 'translate(-50%, 0%)',
    }} />
    : <div id={'more-table-button'} style={{ width: 19, height: '100%', minHeight: 24 }}>
      <div style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        minWidth: '100%',
      }}>
        <MenuItemWithPopover
          icon={<MenuIcon />}
          label={tTables.multiLineActions}
          anchorEl={anchorElMulti}
          setAnchorEl={setAnchorElMulti}
          isLoading={tableMenuStatus === REQUEST_STATUS.loading}
          isSuccess={tableMenuStatus === REQUEST_STATUS.succeeded}
          isFailed={tableMenuStatus === REQUEST_STATUS.failed}
          popoverOptions={tableMenuPopoverOptions(setAnchorElMulti)}
        />
      </div>
    </div>;

};

export default TableMenu;
